export const MANAGER_ROLE = {
  FIELD: "ROLE_FIELD",
  MONITORING: "ROLE_MONITORING",
  MANAGER: "ROLE_MANAGER",
  CALL_CENTER: "ROLE_CALL_CENTER",
  CAFETERIA: "ROLE_CAFETERIA",
  USER: "ROLE_USER",
  ADMIN: "ROLE_ADMIN", // 총 운영자
  SPACE: "ROLE_SPACE",

  // 2024.08.24 비상대피 권한 추가
  EVACUATION_MASTER: "ROLE_EV_MASTER", // 비상대피 마스터
  EVACUATION_COM_ADMIN: "ROLE_EV_COM_ADMIN", // 회사 관리자
  EVACUATION_DEP_ADMIN: "ROLE_EV_DEP_ADMIN", // 부서 관리자
  EVACUATION_EV_USER: "ROLE_EV_USER", // 일반 사용자
};
